module.exports = __webpack_public_path__ + "17b996767ee0373a262c32a16248a3b6.svg";